import React, { useState } from 'react';
import './header.style.css';
import logo from '../../assets/compressed/logoMainH-min.png';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const toggleDrawer = () => {
        setIsDrawerOpen(!isDrawerOpen);
    };

    const handleDrawerItemClick = () => {
        setIsDrawerOpen(false);
    };

    return (
        <header className="header">
            <div className="header-left">
                <img className="header-logo" src={logo} alt="Wild Chips Poker" />
            </div>
            <div className="header-center">
                <div className="header-buttons">
                    <Link to="/" className="header-button">Home</Link>
                    <Link to="/about" className="header-button">About</Link>
                    <Link to="/how-to-play" className="header-button">How to Play</Link>
                    <Link to="/contact-us" className="header-button">Contact Us</Link>
                </div>
            </div>
            <div className="header-right">
                {/* <span>right</span> */}
                <Link to="/login" className="header-button-play">Play</Link>
            </div>

            {/* Hamburger Menu Button */}
            <button className="hamburger-button" onClick={toggleDrawer}>
                <div className={`hamburger-icon ${isDrawerOpen ? 'open' : ''}`}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </button>

            {/* Drawer Menu */}
            <div className={`drawer ${isDrawerOpen ? 'open' : ''}`}>
                <div className="drawer-content">
                    <Link to="/" className="drawer-button" onClick={handleDrawerItemClick}>Home</Link>
                    <Link to="/about" className="drawer-button" onClick={handleDrawerItemClick}>About</Link>
                    <Link to="/how-to-play" className="drawer-button" onClick={handleDrawerItemClick}>How to Play</Link>
                    <Link to="/contact-us" className="drawer-button" onClick={handleDrawerItemClick}>Contact Us</Link>
                    <Link to="/login" className="drawer-button" onClick={handleDrawerItemClick}>Play</Link>
                    {/* <span>right</span> */}
                </div>
            </div>
        </header>
    );
};

export default Header;

